<template>
  <v-main>
    <BaseCrudTable ref="basetable"
                   :headers="headers"
                   @editClicked="editClick"
                   table-name="Направления"
                   endpoint="directions"
                   label="Направления"
                   group-by="report_type_group">
      <template v-slot:editVals>
        <v-col>
          <div ref="form">
            <v-card-text>
              <v-text-field
                ref="name"
                v-model.trim="editItem.name"
                :rules="[() => !!editItem.name || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Имя"
                placeholder="Введите имя"
                required />
            </v-card-text>
            <v-card-text>
              <v-text-field
                ref="additional_name"
                v-model.trim="editItem.additional_name"
                label="Дополнительная информация"
                placeholder="Введите информацию"
                required />
            </v-card-text>
            <v-card-text>
              <v-select
                ref="producttype"
                v-model="editItem.producttype"
                :items="productTypes"
                :rules="[() => !!editItem.producttype || 'Поле обязательно']"
                :error-messages="errorMessages"
                item-text="name"
                item-value="id"
                label="Выберите Тип продукта"
                required />
            </v-card-text>
            <v-card-text>
              <BaseAutoComplete ref="report_type"
                                v-model="editItem.report_type"
                                :items="reportTypeItems"
                                :rules="[() => !!editItem.report_type || 'Поле обязательно']"
                                :value="reportTypeSelected"
                                :error-messages="errorMessages"
                                @updateSelected="updateReportTypes"
                                label="Доступные отчеты"
                                required />
            </v-card-text>
            <v-card-text>
              <v-select ref="report_availability"
                        v-model="editItem.report_availability"
                        :items="reportAvailabilityItems"
                        :error-messages="errorMessages"
                        item-text="name"
                        item-value="id"
                        label="Видимость"
                        required />
            </v-card-text>
            <v-card-actions>
              <v-btn @click="close()" text>
                Отмена
              </v-btn>
              <v-spacer />
              <v-slide-x-reverse-transition>
                <v-tooltip
                  v-if="formHasErrors"
                  left />
              </v-slide-x-reverse-transition>
              <v-btn @click="submit" color="primary" text>
                Подтвердить
              </v-btn>
            </v-card-actions>
          </div>
        </v-col>
      </template>
    </BaseCrudTable>
  </v-main>
</template>

<script>
import BaseCrudTable from '../base/BaseCrudTable'
import BaseAutoComplete from '../base/BaseAutoComplete'

import {mapState} from 'vuex'

export default {
  name: "DirectionsTable",
  components: {BaseCrudTable, BaseAutoComplete},
  data () {
    return {
      headers: [
        // {text: '', value: '', align: 'left'},
        {text: '', value: 'importance', align: 'left'},
        {text: 'id', value: 'id', align:  'd-none', class:['d-none']},
        {text: 'Название', value: 'name', align: 'left'},
        // {text: 'Классификатор', value: 'classificator', align: 'left'},
        {text: 'Отчет', value: 'report_type', align: 'd-none',class: ['d-none']},
        {text: 'Отчет', value: 'report_type_group', align: 'left'},
        {text: 'Тип продукта', value: 'producttype', align: 'left'},

        {text: 'Видимость', value: 'report_availability', align: 'left'},
        {text: 'Действия', value: '', align: 'center'}
      ],
      editItem: {
        name: '',
        additional_name: '',
        // classificator: '',
        producttype: '',
        report_availability: '',
        report_type: [{'id':'case','name':'КМ'}],
        id: ''
      },
      dialog: false,
      errorMessages: '',
      formHasErrors: false,
      reportTypeSelected: []

    }
  },
   computed: {
    form () {
      return {
        name: this.editItem.name,
        additional_name: this.editItem.additional_name,
        producttype: this.editItem.producttype,
        report_type: this.editItem.report_type
      }
    },
    ...mapState({
      productTypes: state => state.tableData.productTypes.filter(p => { return p.id !== 2 }),
    })
  },
  methods: {
    editClick (newVal) {
      this.simpleEditClick(newVal)

    },
    submit () {
      this.formSubmit()
      this.$store.dispatch("tableData/loadDirections")
    },
    close () {
      this.$refs["basetable"].close()
    },
    updateReportTypes (newVal) {
      this.editItem.report_type = newVal
      this.reportTypeSelected = newVal
    },
  }


}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/DirectionsTable.vue